import { render, staticRenderFns } from "./WebChatCmp.vue?vue&type=template&id=fb2750f6&"
import script from "./WebChatCmp.vue?vue&type=script&lang=js&"
export * from "./WebChatCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports